import React, { useState, useEffect, useImperativeHandle } from 'react';
import apis from '@/apis/goodsPool';
import { Button, message } from '@drip/drip-design';
import PageAdapter from '@/components/page-adapter';
import './index.less';

function SubStrategyList(props, ref) {
  const { activityId, goSelect } = props;
  const [subStrategyList, setSubStrategyList] = useState([]); //子策略维度货盘
  const [refresh, setRefresh] = useState(0);

  useImperativeHandle(ref, () => ({
    refresh: () => {
      setRefresh(refresh + 1);
    },
  }));

  useEffect(() => {
    if (!activityId) return;
    apis
      .subStrategyList({ activityId })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data?.list) throw msg;
        setSubStrategyList(data.list);
      })
      .catch((ex) => {
        message.error(ex || '子策略维度货盘获取失败！');
      });
  }, [activityId, refresh]);

  return (
    subStrategyList.length > 0 && (
      <div className="sub-strategy-list">
        <div className="sub-strategy-list-title">子策略维度货盘</div>
        <div style={{ height: '65px' }}>
          <PageAdapter row={1} blockWidth={303} blockHeight={64} space={[20, 20]} empty={null}>
            {subStrategyList.map((item) => (
              <div key={item.strategyId} className="sub-strategy-list-item">
                <span className="__list-tag">品类</span>
                <div className="__list-name">{item.subStrategyName}</div>
                <Button
                  className="__list-button"
                  type="primary"
                  ghost
                  size="small"
                  onClick={() => goSelect([item], item.inventories)}
                >
                  去选品
                </Button>
              </div>
            ))}
          </PageAdapter>
        </div>
      </div>
    )
  );
}

export default React.forwardRef(SubStrategyList);
